<template>
  <div
    class="device-container d-flex flex-column mb-3 cursor-pointer"
    :class="{
      'device-in-focus': inFocus,
    }"
    @click="viewGroup"
  >
    <div class="d-flex h-100 p-3">
      <div class="d-flex justify-content-center flex-column">
        <h2 class="m-b-5 font-18">{{ group.name }}</h2>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "GroupCard",
  props: {
    group: Object,
    groupInFocus: Object,
  },
  data() {
    return {
      inFocus: false,
    };
  },
  mounted() {
    if (this.groupInFocus.id == this.group.id) {
      this.inFocus = true;
    }
  },
  watch: {
    groupInFocus: {
      handler: function() {
        this.inFocus = false;
        if (this.groupInFocus.id == this.group.id) {
          this.inFocus = true;
        }
      },
      deep: true,
    },
  },
  methods: {
    viewGroup() {
      this.$emit("view-group", this.group);
    },
  },
};
</script>

<style scoped>
.device-top {
  height: 3px;
  border-radius: 5px 5px 0px 0px;
}
.critical {
  background: #eb5757;
}
.stable {
  background: #213e7a;
}
.device-container {
  /* height: 108px; */
  /* border-bottom: ; */
  padding-left: 24px;
  box-shadow: 0px 1px 0px #e1e7ec;
}
.icon-box {
  height: 30px;
  width: 30px;
  border: 1px solid;
  border-radius: 5px;
}
.device-in-focus {
  background: #DEE2EB !important;
  color: #213e7a !important;
  cursor: default !important;
}
.cursor-pointer:hover {
  background: #8d968f;
  color: white;
}
</style>
